import { useState } from "react";
import { Navigate } from "react-router-dom";

import { ApiError } from "../api/client";
import { ErrorBand } from "../components/ErrorBand";
import { Skeleton } from "../components/Skeleton";
import { useLogin, useSession } from "../auth";
import "./pages.css";

export function Login() {
  const { me, loading } = useSession();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (loading) return <Skeleton rows={3} />;
  if (me) return <Navigate to="/" replace />;

  return (
    <main className="login">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          login.mutate({ email, password });
        }}
      >
        <h1>Market</h1>
        <p className="lede">Item Broker prices, kept across months.</p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" disabled={login.isPending}>
          {login.isPending ? "Signing in…" : "Sign in"}
        </button>

        {/* The uniform message for a 401 is deliberate: the server answers 401
            for a wrong password, an unknown account and a disabled account
            alike, and telling them apart would make this form a directory of
            who has an account. A 500, a proxy's 502 and a dead network
            (ApiError(0)) are not sign-in failures and must not claim to be. */}
        {login.isError ? (
          login.error instanceof ApiError && login.error.status === 401 ? (
            <ErrorBand
              message="Wrong email or password."
              hint="Accounts here are invite-only. Ask whoever runs this for an invite."
            />
          ) : (
            <ErrorBand
              message="Could not reach the server."
              hint="This is not a sign-in problem — the service is unreachable or erroring. Try again in a moment."
            />
          )
        ) : null}
      </form>
    </main>
  );
}
